export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13754.88996273.jpg";